<template>
    <a-modal
        id="messenger-integrate-modal"
        :title="title"
        wrapClassName="vertical-center-modal"
        :visible="modalVisable"
        @visibleChange="(isVisible) => $emit('modal-visible2', isVisible)"
        :footer="null"
        @cancel="close()"
    >
        <div class="list-container" v-for="(item, index) in cloneChannels" :key="index">
            <div class="integration-channel-name">
                <div class="page-card-body-content-item-image">
                    <img :src="item.payload.page.picture.data.url" alt="page image" />
                </div>

                <div v-tippy="{ content: item.name }" class="channel-name">
                    {{ item.name }}
                </div>
            </div>

            <div class="mt-1 mb-1">
                <span> 👉 {{ $t("whatsappChannel.forwardingChatbotOrLiveAgent") }}</span>
            </div>

            <div>
                <a-select :default-value="''" v-model="item.forward.story">
                    <a-select-option :value="''" :selected="true"> 👉 Forward Live Agents</a-select-option>
                    <a-select-option v-for="story in filteredStories" :key="story._id" :value="story._id">
                        {{ story.title }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <div class="actions">
            <SupsisButton ghost @click="close">
                {{ $t("wp.cancel") }}
            </SupsisButton>
            <SupsisButton primary :disabled="!isChanged()" @click="updateMultiChannel">
                <i class="material-icons">save</i>
                {{ $t("chatbotv2.save") }}
            </SupsisButton>
        </div>
    </a-modal>
</template>
<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import { sendSocketMessage } from "../../../../../../utils/socketStream";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";
import confetti from 'canvas-confetti';

export default {
    name: "MessengerIntegrationsModal",

    props: {
        title: {
            type: String,
            default: "",
        },
        modalVisable: {
            type: Boolean,
            default: false,
        },
        channels: {
            type: Array,
            default: () => [],
        },
        storyId: {
            type: String,
            default: "",
        },
    },
    components: {
        SupsisButton,
    },
    data() {
        return {
            showStories: false,
            cloneChannels: [],
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            siteId: (state) => _.get(state.site.site, "_id"),
            messengerChannels: (state) => state.channel.channels.filter((channel) => channel.type === "messenger"),
        }),
        filteredStories() {
            if (this.storyId) {
                return this.stories.filter(story => story._id === this.storyId);
            }
            return this.stories;
        },
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listStories: "CB/listStories",
            listChannels: "channel/listChannels",
        }),
        checkHaveChatbotStory(id) {
            return this.stories.find((story) => story._id === id);
        },
        toggleChatbot(item) {
            item.forward.story = null;
            item.showStories = false;
            this.updateChannelData(item);
        },
        isChanged() {
            return !_.isEqual(this.cloneChannels, this.messengerChannels);
        },
        runSuccessConfetti() {
            const end = Date.now() + (3 * 1000); // 3 saniye
            const colors = ['#bb0000', '#ffffff'];

            const frame = () => {
                confetti({
                    particleCount: 2,
                    angle: 60,
                    spread: 55,
                    origin: { x: 0 },
                    colors: colors
                });
                confetti({
                    particleCount: 2,
                    angle: 120,
                    spread: 55,
                    origin: { x: 1 },
                    colors: colors
                });

                if (Date.now() < end) {
                    requestAnimationFrame(frame);
                }
            };

            frame();
        },
        async updateMultiChannel() {
            const updatedChannels = this.cloneChannels.filter((updatedChannel) => {
                const original = this.messengerChannels.find((y) => y._id === updatedChannel._id);
                return !_.isEqual(updatedChannel, original);
            });
            this.loading = true;
            const promises = updatedChannels.map((channel) => this.updateChannelData(channel));
            const results = await Promise.all(promises);
            const isSuccess = results.every((x) => x);
            this.loading = false;
            this.listChannels();
            if (isSuccess) {
                this.$message.success("Channels updated successfully");
                this.runSuccessConfetti();
            } else {
                this.$message.error("Failed to update channel");
            }

            sendSocketMessage("user wp-channel-updated", {
                siteId: this.siteId,
            });
            this.$emit("submit");
        },
        updateChannelData(channel) {
            if (channel.forward.story === "") {
                channel.forward.mode = "live";
                channel.forward.story = null;
            } else {
                channel.forward.mode = "chatbot";
            }
            return this.updateChannel(channel)
                .then(() => true)
                .catch((err) => false);
        },
        close() {
            this.$emit("close");
        },
    },
    mounted() {
        this.listStories();
        this.cloneChannels = _.cloneDeep(this.messengerChannels);
    },
    watch: {
        messengerChannels: {
            handler(val) {
                this.cloneChannels = _.cloneDeep(val);
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
#messenger-integrate-modal {
    width: 100%;
    width: 900px;

    .ant-modal-content {
        width: 900px !important;
        border-radius: 10px;
    }

    .ant-modal-header {
        border-radius: 10px 10px 0 0;
    }

    .ant-modal-body {
        border-radius: 0 0 10px 10px;
    }

    .list-container {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #e8e8e8;
        padding-bottom: 5px;
        margin-bottom: 10px;
        align-items: center;
    }

    .integration-channel-name {
        display: flex;
        align-items: center;
        gap: 5px;

        .page-card-body-content-item-image {
            flex: 0 0 80px;

            img {
                border-radius: 50%;
                height: 80px;
                width: 80px;
            }
        }
    }

    .whatsapp-icon {
        width: 20px;
        height: 20px;
    }

    .save-btn {
        background: transparent;
        border: transparent;
        color: #169d0d;
    }

    .cancel-btn {
        background: transparent;
        border: transparent;
        color: red;
    }

    .ant-select-selection {
        width: 200px !important;
    }

    .channel-name {
        width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .actions {
        gap: 5px;
        display: flex;
        justify-content: flex-end;
    }
}
</style>
